<!--用户管理新建档案页面-->
<template>
  <a-spin :spinning="confirmLoading">
    <a-steps :current="current" style="margin-bottom: 20px">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" :colon="false">
        <div>
          <a-collapse v-model="activeKey">
            <a-collapse-panel key="1" header="表具信息">
              <a-row :gutter="16">
                <a-col :span="8">
                  <a-form-item label="表编号">
                    <a-input v-decorator="['meterId',validatorRules.meterId]" placeholder="请输入表编号"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="安装经度">
                    <a-input-number v-decorator="['userMeterLng',validatorRules.userMeterLng]" placeholder="请输入水表安装经度" style="width:100%"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="安装维度">
                    <a-input-number v-decorator="['userMeterLat',validatorRules.userMeterLat]" placeholder="请输入水表安装维度" style="width:100%"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="表安装地址">
                    <a-input v-decorator="['userAddr',validatorRules.userAddr]" placeholder="请输入水表安装地址"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="表计费起始读数">
                    <a-input-number v-decorator="['userMeterStartNum',validatorRules.userMeterStartNum]" :disabled="this.model.userState==1" placeholder="请输入用户表计费起始读数" style="width:100%"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="开户时表读数">
                    <a-input-number v-decorator="['userMeterOpenNum',validatorRules.userMeterOpenNum]" placeholder="请输入用户开户时表读数" style="width:100%"/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="开户时阀门开关状态">
                    <a-select  v-decorator="['userValveOpenorclose',validatorRules.userValveOpenorclose]" placeholder="请选择开户时阀门开关状态" :popper-append-to-body="true" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                      <a-select-option :value="0">
                        无动作
                      </a-select-option>
                      <a-select-option :value="1">
                        开阀
                      </a-select-option>
                      <a-select-option :value="2">
                        关阀
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-collapse-panel>
            <a-collapse-panel key="2" header="区域/用户信息">
              <a-row>
              <a-col :span="12">
                <a-form-item label="区域名称"  :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" hasFeedback >
                  <a-tree-select
                    style="width:100%"
                    :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
                    :treeData="treeData"
                    :labelInValue="true"
                    v-decorator="['userArea',validatorRules.userArea]"
                    placeholder="请选择上级区域"
                    :disabled="condition"
                    allow-clear
                    :append-to-body="false"
                    :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
                    tree-default-expand-all>
                  </a-tree-select>
                </a-form-item>
              </a-col>
              </a-row>
              <div>
                <a-row :gutter="16">
                  <a-col :span="8">
                    <a-form-item label="用户编号">
                      <a-input v-decorator="['userId',validatorRules.userId]" placeholder="请输入用户编号"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="用户姓名">
                      <a-input v-decorator="['userName',validatorRules.userName]" placeholder="请输入用户姓名"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="手机号码">
                      <a-input v-decorator="['userPhone',validatorRules.userPhone]" placeholder="请输入用户手机号"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="8">
                    <a-form-item label="身份证号">
                      <a-input v-decorator="['userIdNumber',validatorRules.userIdNumber]" placeholder="请输入身份证号"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="户型ID">
                      <a-select v-decorator="['userHouseholdCode',validatorRules.userHouseholdCode]" placeholder="请选择用户户型id" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <a-select-option v-for="data in userHouseholdCodeList" :key="data.id" :value="data.id">
                          {{ data.htName }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="类型编码">
                      <a-select v-decorator="['userTypeCode',validatorRules.userTypeCode]" placeholder="请选择用户类型编码" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                          {{data.utName}}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="价格名称">
                      <a-select v-decorator="['userPriceCode',validatorRules.userPriceCode]" placeholder="请选择用户价格名称" :disabled="this.model.userState==1" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id" >
                          <a-tooltip>
                            <template slot="title">
                              单价:{{data.wtTotalPrice/100}}元
                            </template>
                            {{data.wtName}}
                          </a-tooltip>
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-form-item label="表安装地址" >
                    <a-input v-decorator="['userMeterAddr',validatorRules.userMeterAddr]" placeholder="请输入水表安装地址"></a-input>
                  </a-form-item>
                </a-row>
                <a-row>
                  <a-form-item label="备注" >
                    <a-textarea v-decorator="['remark']" rows="3" placeholder="请输入备注" style="width:100%"/>
                  </a-form-item>
                </a-row>
              </div>
              <a-collapse v-model="defaultkey">
                <a-collapse-panel key="4" header="用户选填信息" :forceRender="true">
                  <a-row :gutter="16">
                    <a-col :span="8">
                      <a-form-item label="营收编号">
                        <a-input v-decorator="['userPayId']" placeholder="请输入用户营收编号"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="类型" >
                        <a-select  v-decorator="['userIdType']" placeholder="请选择类型" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                          <a-select-option :value="1">
                            自然人
                          </a-select-option>
                          <a-select-option :value="0">
                            企业
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="小区名或村庄名">
                        <a-input v-decorator="['userCommName']" placeholder="请输入用户所在小区名或村庄名"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="是否允许缴费" >
                        <j-dict-select-tag v-decorator="['userPayState', validatorRules.userPayState]" :triggerChange="true" placeholder="请选择是否允许缴费" dictCode="yn" style="width:100%"/>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="优惠信息">
                        <a-select v-decorator="['userFreeinfo']" placeholder="请选择优惠信息" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <a-select-option value="1">
                          按户
                        </a-select-option>
                        <a-select-option value="2">
                          按人
                        </a-select-option>
                        <a-select-option value="3">
                          按月
                        </a-select-option>
                        <a-select-option value="4">
                          按量
                        </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-collapse-panel>
              </a-collapse>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { listSize } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import { duplicateCheck,queryAreaTreeList } from '@/api/api'
  export default {
    name: 'MeterUserinfoForm',
    components: {
      JFormContainer,
    },
    data () {
      return {
        seen:false,
        treeData:[],
        condition:false,
        activeKey:[1,2],
        defaultkey:'',
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          meterId:{   //表编号
            rules:[
              {required: true, len:14 , message: '请输入表编号!'},
              {validator: this.validatePlanName}, 
            ]
          },
          userAreaId:{  // 区域id
            rules:[
              {required:true, message:'请输入用户区域id！'},
            ]
          },
          userPriceCode:{  //价格名称
            rules:[
              {required:true, message:'请选择价格编码！'},
            ]
          },
        },
        userHouseholdCodeList:[], // 用户户型
        userTypeList:[], //  类型编码
        userPriceCode:[], // 价格编码
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          userHouseholdCodeList: "/jeecg-charge/meter/meterHousehold/list",
          userTypeList: "/jeecg-charge/meter/meterUserType/list",
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",
        },
        current: 0,
        steps: [
          {
            title: '地址信息',
          },
          {
            title: '用户信息',
          },
          {
            title: '户号绑定',
          }
        ]
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      loadTreeData() {
        console.log("查询区域")
        var that = this;
        queryAreaTreeList().then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            that.treeData = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
            }
          }
        })
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.loadTreeData();
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'meterId','userId','userName','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddr','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName','userState','userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'));
          this.form.setFieldsValue({userArea: {label: this.model.userAreaName,value: this.model.userAreaId}});
        })
        this.queryUserHouseholdCodeList();
        this.queryUserTypeList();
        this.queryUserPriceCode();
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit(res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log(values);
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log(this.model);
            formData.userAreaName = values.userArea.label;
            formData.userAreaId = values.userArea.value;
            console.log("表单提交数据",formData);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      queryUserHouseholdCodeList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userHouseholdCodeList, params).then((res) => {
          if(res.success){
           this.userHouseholdCodeList = res.result.records;
          }
        })
      },
      queryUserTypeList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
           this.userTypeList = res.result.records;
          }
        })
      },
      queryUserPriceCode() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
          }
        })
      },
      // 查询表编号名称是否重复
      validatePlanName(rule, value, callback){
        var params ={
         tableName:'meterinfo',
         fieldName:'meter_id',
         fieldVal:value,
         dataId:this.model.id
        };
        console.log(params);
        duplicateCheck(params).then((res) => {
          console.log(res);
          if (res.success) {
            callback("请在表具信息页面中添加")
          } else {
            callback() 
          }
        })
      },
      shut(){    //关闭按钮
        this.defaultkey = '';
        this.form.resetFields();
      }
    },
  }
</script>
<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
</style>